import { render, staticRenderFns } from "./VeracruzTipoAnestesia.vue?vue&type=template&id=6f78170f&scoped=true"
import script from "./VeracruzTipoAnestesia.vue?vue&type=script&lang=ts"
export * from "./VeracruzTipoAnestesia.vue?vue&type=script&lang=ts"
import style0 from "./VeracruzTipoAnestesia.vue?vue&type=style&index=0&id=6f78170f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78170f",
  null
  
)

export default component.exports